import { z } from "zod";


export const createContractSchema = z.object({
  clientId:            z.string().uuid(),
  name:                z.string().min(1).max(200),
  workLine:            z.enum(['nacional', 'internacional', 'batea']).default('batea'),
  monthlyTargetTn:     z.coerce.number().positive(),
  refWeightTnPerTruck: z.coerce.number().positive(),
  startDate:           z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  endDate:             z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable().optional(),
  notes:               z.string().max(1000).nullable().optional(),
});
export const updateContractSchema = createContractSchema.partial();

export const createContractWeekSchema = z.object({
  weekLabel:     z.string().min(1).max(50),
  weekStartDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  weekEndDate:   z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  targetTn:      z.coerce.number().positive(),
  notes:         z.string().max(1000).nullable().optional(),
});
export const updateContractWeekSchema = createContractWeekSchema.partial();

export const createContractMonthlyTargetSchema = z.object({
  yearMonth: z.string().regex(/^\d{4}-\d{2}$/, "Formato requerido: YYYY-MM"),
  targetTn:  z.coerce.number().positive(),
});
export const updateContractMonthlyTargetSchema = createContractMonthlyTargetSchema.partial();

export type CreateContractMonthlyTargetInput = z.infer<typeof createContractMonthlyTargetSchema>;
export type UpdateContractMonthlyTargetInput = z.infer<typeof updateContractMonthlyTargetSchema>;

export type CreateContractInput      = z.infer<typeof createContractSchema>;
export type UpdateContractInput      = z.infer<typeof updateContractSchema>;
export type CreateContractWeekInput  = z.infer<typeof createContractWeekSchema>;
export type UpdateContractWeekInput  = z.infer<typeof updateContractWeekSchema>;
